import { GridColDef } from "@mui/x-data-grid";
import DetailButton from "./DetailButton";
import dayjs from "dayjs";

export const emailLogColumns: GridColDef[] = [
  {
    field: "",
    renderCell: DetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "toEmail",
    headerName: "Alıcı Email",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "subject",
    headerName: "Konu",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "isSent",
    headerName: "Gönderildi Mi?",
    type: "boolean",
    width: 120,
  },
  {
    field: "sentTime",
    headerName: "Gönderim Tarihi",
    type: "dateTime",
    width: 180,
    valueGetter: (v) => (v ? new Date(v) : null),
  },
  {
    field: "errorMessage",
    headerName: "Hata Mesajı",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "retryCount",
    headerName: "Tekrar Deneme",
    type: "number",
    width: 120,
  },
  {
    field: "nextRetryTime",
    headerName: "Sonraki Deneme",
    type: "dateTime",
    width: 180,
    valueGetter: (v) => (v ? new Date(v) : null),
  },
  {
    field: "creationTime",
    headerName: "Kayıt Tarihi",
    type: "dateTime",
    width: 180,
    valueGetter: (v) => (v ? new Date(v) : null),
  },
];
